/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Prevent font size inflation */
html {
  -moz-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
}

/* Remove default margin in favour of better control in authored CSS */
body, h1, h2, h3, h4, p,
figure, blockquote, dl, dd {
  margin-block-start: 0;
  margin-block-end: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role=list],
ol[role=list] {
  list-style: none;
}

/* Set core body defaults */
body {
  min-height: 100vh;
  line-height: 1.5;
  margin: 0;
}

/* Set shorter line heights on headings and interactive elements */
h1, h2, h3, h4,
button, input, label {
  line-height: 1.1;
}

/* Balance text wrapping on headings */
h1, h2,
h3, h4 {
  text-wrap: balance;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
  color: currentColor;
}

/* Make images easier to work with */
img,
picture {
  max-width: 100%;
  display: block;
}

/* Inherit fonts for inputs and buttons */
input, button,
textarea, select {
  font-family: inherit;
  font-size: inherit;
}

/* Make sure textareas without a rows attribute are not tiny */
textarea:not([rows]) {
  min-height: 10em;
}

/* Anything that has been anchored to should have extra scroll margin */
:target {
  scroll-margin-block: 5ex;
}

/* Remove margins on p tags */
p {
  margin-block-start: 0;
}

@keyframes blurReveal {
  0% {
    opacity: 0;
    filter: blur(8px);
    transform: translateY(-15px);
  }
  100% {
    opacity: 1;
    filter: blur(0px);
    transform: translateY(0);
  }
}
@keyframes moveUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100px);
  }
}
img.lazy {
  filter: blur(5px);
}

.coxtainer {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(20px, 1fr) minmax(100px, 1160px) minmax(20px, 1fr);
}
.coxtainer > * {
  grid-column: 2/3;
}
.coxtainer > .full-width {
  grid-column: 1/4;
}

@font-face {
  font-family: "Fatfrank";
  src: url("../fonts/fatfrank/FatFrank-Regular.eot");
  src: url("../fonts/fatfrank/FatFrank-Regular.eot?") format("embedded-opentype"), url("../fonts/fatfrank/FatFrank-Regular.woff") format("woff"), url("../fonts/fatfrank/FatFrank-Regular.ttf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
h1, h2, h3 {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  font-weight: 400;
}

#main p {
  margin-bottom: 1.5em;
}

.absolute-header .header_wrapper {
  z-index: 100;
  width: 100%;
}

.absolute-header .header_wrapper {
  position: absolute;
  left: 0;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 150px;
}
header .logo {
  width: 300px;
}
header .menu {
  display: none;
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  transition: background;
}
@media (min-width: 1024px) {
  header .menu {
    display: flex;
    text-align: right;
    padding-top: 1rem;
    flex-direction: row;
    column-gap: 1em;
  }
}
header .menu .navbar-item {
  padding-top: 0.6rem;
}
header .menu a {
  text-decoration: none;
}
header .hamburger {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  width: 30px;
}
@media (min-width: 1024px) {
  header .hamburger {
    display: none;
  }
}
header .hamburger__bun-top, header .hamburger__patty, header .hamburger__bun-bottom {
  background: var(--header-colour);
  width: 100%;
  height: 3px;
  transform-origin: 50% 50%;
  transition: transform 0.3s ease-out;
}
header .hamburger--open {
  z-index: 201;
}
header .hamburger--open .hamburger__patty {
  display: none;
}
header .hamburger--open .hamburger__bun-top {
  transform: rotate(45deg) translateY(5px);
}
header .hamburger--open .hamburger__bun-bottom {
  transform: rotate(-45deg) translateY(-6px);
}

.menu-mobile {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  transition: background;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 20;
  font-size: 32px;
  animation: menu-fade-in 0.5s ease-out;
}
.menu-mobile--open {
  display: flex;
}
@media (min-width: 1024px) {
  .menu-mobile {
    display: none;
  }
}
.menu-mobile .navbar-item {
  padding-top: 0.6rem;
}
.menu-mobile a {
  text-decoration: none;
  color: #fff;
  animation: menu-item-fade-in 0.3s ease-out;
  animation-fill-mode: backwards;
  animation-delay: 0.1s;
}
.menu-mobile a:nth-child(2) {
  animation-delay: 0.15s;
}
.menu-mobile a:nth-child(3) {
  animation-delay: 0.2s;
}
.menu-mobile a:nth-child(4) {
  animation-delay: 0.25s;
}
.menu-mobile a:nth-child(5) {
  animation-delay: 0.3s;
}
.menu-mobile a:nth-child(6) {
  animation-delay: 0.35s;
}
.menu-mobile a:nth-child(7) {
  animation-delay: 0.4s;
}

@keyframes menu-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes menu-item-fade-in {
  0% {
    opacity: 0;
    transform: scale(1.5) translateX(100px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateX(0px);
  }
}
.logo #ghost {
  -webkit-animation: bob 1.5s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate;
  animation: bob 1.5s cubic-bezier(0.37, 0, 0.63, 1) infinite alternate;
}
.logo #ghost #lid1, .logo #ghost #lid2 {
  animation: blink 3.3s infinite;
  stroke: var(--header-colour);
  fill: var(--header-colour);
}
.logo #ghost #pupil1, .logo #ghost #pupil2 {
  fill: var(--header-colour);
}
.logo #ghost #eye1, .logo #ghost #eye2 {
  stroke: var(--header-colour);
}
.logo #ghost #body path {
  stroke: var(--header-colour);
}
.logo #ghost #body polygon {
  fill: var(--header-colour);
}
.logo #type path {
  fill: var(--header-colour);
}

@keyframes bob {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10px);
  }
}
@keyframes blink {
  94% {
    opacity: 0;
  }
  95% {
    opacity: 1;
  }
  96% {
    opacity: 1;
  }
  97% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.standard__header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 150px;
  margin-bottom: 100px;
}
.standard__header__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  animation: work-header 0.2s ease-out;
}
.standard__header__text {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}
.standard__header__text h1 {
  margin-top: 0;
}
.standard__header__text .standard__header__intro,
.standard__header__text .standard__header__intro p {
  font-size: 3rem;
}
.footer {
  margin-top: 40px;
  padding-top: 40px;
  padding-bottom: 40px;
  background: rgba(0, 0, 0, 0.1333333333);
}
.footer a {
  text-decoration: none;
  font-weight: 700;
}
.footer__cols {
  display: flex;
  justify-content: center;
  gap: 20px;
}
@media (min-width: 769px) {
  .footer__cols {
    justify-content: space-between;
  }
}
.footer__menu {
  display: flex;
  gap: 10px;
}

.password-form {
  padding: 40px 20px;
  margin-bottom: 30px;
  border: 2px dashed var(--text-colour);
  border-radius: 10px;
  text-align: center;
}
.password-form p {
  font-weight: 600;
  margin-bottom: 10px;
}
.password-form input[type=password], .password-form input[type=submit] {
  background: transparent;
  border: 1px solid var(--text-colour);
  color: var(--text-colour);
  text-transform: capitalize;
  font-weight: 600;
  font-size: 18px;
  border-radius: 4px;
  padding: 10px 20px;
}
.password-form input[type=submit] {
  background: var(--text-colour);
  color: var(--bg-colour);
  border: 1px solid var(--text-colour);
}

.works {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.works__item {
  position: relative;
  aspect-ratio: 1.618/1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid var(--text-colour);
}
@media (min-width: 1024px) {
  .works__item {
    aspect-ratio: 3/1;
  }
}
.works__item h2 {
  position: relative;
  z-index: 3;
  transition: transform 0.3s ease-out;
}
@media (min-width: 1024px) {
  .works__item h2 {
    opacity: 0;
    transform: translateY(200px);
  }
}
.works__item img, .works__item__cover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
}
.works__item img {
  object-fit: cover;
  object-alignment: center;
}
.works__item__cover {
  z-index: 2;
  opacity: 0.617;
  transition: opacity 0.2s ease-out;
}
@media (min-width: 1024px) {
  .works__item__cover {
    opacity: 0;
  }
}
.works__item:hover h2 {
  opacity: 1;
  transform: translateY(0);
}
.works__item:hover .works__item__cover {
  opacity: 0.617;
}
.works__item--private {
  background: rgba(0, 0, 0, 0.2);
  border: 2px dashed var(--text-colour);
}
.works__item--private svg {
  width: 64px;
}
.works__item--private svg path {
  stroke: var(--text-colour);
}
.works__item--private h2 {
  opacity: 1;
  transform: none;
}

.contact__grid {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 2rem;
  align-items: start;
  margin-top: 2rem;
}

.contact__form-wrapper {
  background: rgba(255, 255, 255, 0.1);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}

.contact__form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.contact__form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.contact__form label {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-colour);
}

.form-control {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: var(--text-colour);
  font-size: 1rem;
  color: var(--bg-colour);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.contact__form input,
.contact__form textarea {
  width: 100%;
  display: block;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: var(--text-colour);
  font-size: 1rem;
  color: var(--bg-colour);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.contact__form input:focus,
.contact__form textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.contact__submit {
  justify-self: start;
  padding: 0.9rem 1.4rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: var(--text-colour);
  color: var(--bg-colour);
  font-family: "FatFrank", "Fatfrank", sans-serif;
  font-size: 1rem;
  transition: transform 0.15s ease, background 0.2s ease;
}

.contact__submit:hover {
  transform: translateY(-1px);
  /* keep accessible contrast */
  opacity: 0.95;
}

.contact__message {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  margin-bottom: 0.5rem;
}

.contact__message--success {
  background: #e6f4ea;
  color: #1e4620;
}

.contact__message--error {
  background: #fbeaea;
  color: #8a1f1f;
}

@media (max-width: 900px) {
  .contact__grid {
    grid-template-columns: 1fr;
  }
  .contact__form-wrapper {
    padding: 1.25rem;
  }
}
.home__header {
  margin-top: 75px;
  margin-bottom: 100px;
  min-height: 200px;
}
@media (min-width: 769px) {
  .home__header {
    margin-top: 150px;
    margin-bottom: 200px;
  }
}
.home__header h1 {
  display: block;
  font-size: 2em;
  line-height: 1.2;
  font-weight: 100;
  text-align: center;
  animation: moveUp linear both;
  animation-timeline: view();
}
@media (min-width: 769px) {
  .home__header h1 {
    font-size: 3.5em;
    line-height: 1.2;
  }
}
.home__header h1 strong {
  opacity: 0.75;
}

/**
 * Single portfolio item
 */
:root {
  --height-difference: 0px;
  --anim-speed: 2s;
}

.work__nav {
  position: absolute;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
}
.work__nav svg {
  width: 40px;
  height: auto;
  transition: fill 0.3s ease;
  transform: scaleY(-1) rotate(-120deg);
}
.work__nav svg path {
  fill: var(--text-colour);
}
.work__nav a {
  font-size: 12px;
  text-decoration: none;
  color: var(--color-text);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.work__nav--pevious {
  left: 20px;
}
.work__nav--next {
  right: 20px;
}
.work__nav--next svg {
  transform: scaleY(1) rotate(50deg);
}
.work__chrome {
  width: 100%;
  aspect-ratio: 16/9;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
}
.work__chrome__address {
  color: #999;
  position: absolute;
  z-index: 2;
  top: 3%;
  left: 14%;
  font-size: clamp(10px, 2.3cqw, 20px);
}
@media (min-width: 769px) {
  .work__chrome__address {
    font-size: clamp(10px, 1.15cqw, 20px);
  }
}
@media (min-width: 1024px) {
  .work__chrome__address {
    font-size: 14px;
    top: 8px;
  }
}
.work__chrome__image {
  position: absolute;
  z-index: 1;
  top: 12%;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.work__chrome__image img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  animation: work-chrome var(--anim-speed) ease-out infinite;
}
@keyframes work-chrome {
  0% {
    top: 0;
  }
  5% {
    top: 0;
  }
  75% {
    top: var(--height-difference);
  }
  100% {
    top: 0;
  }
}
.work__header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 150px;
  margin-bottom: 100px;
}
.work__header__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 50px;
  animation: work-header 0.2s ease-out;
}
@media (min-width: 769px) {
  .work__header__grid {
    grid-template-columns: 1fr 1fr;
  }
}
.work__header__text {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}
.work__header__text h1 {
  margin-top: 0;
}
.work__header__text a {
  opacity: 0.5;
  transition: opacity 0.3s ease;
  text-decoration: none;
}
.work__header__text a:hover {
  opacity: 1;
}
.work__header__text .work__header__intro {
  opacity: 0.75;
}
.work__next__link {
  display: grid;
  grid-template-columns: 300px 1fr;
  padding: 20px;
  margin-bottom: 20px;
  gap: 30px;
  border-radius: 8px;
  text-decoration: none;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}
.work__next__text {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}

@keyframes work-header {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.about__header {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 150px;
  margin-bottom: 100px;
}
.about__header__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  animation: work-header 0.2s ease-out;
}
.about__header__text {
  font-family: "FatFrank", asap, "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: regular;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}
.about__header__text h1 {
  margin-top: 0;
}
.about__header__text .about__header__intro {
  font-size: 3rem;
}
.blog-listing__grid__item {
  text-decoration: none;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}
@media (min-width: 769px) {
  .blog-listing__grid__item {
    grid-template-columns: 1fr 1fr;
  }
}
.blog-listing__grid__item img {
  width: 100%;
  height: auto;
  border-radius: 15px;
}

.cox-block {
  margin-bottom: 100px;
}

/*_     _     _     _     _            _    
| |   (_)___| |_  | |__ | | ___   ___| | __
| |   | / __| __| | '_ \| |/ _ \ / __| |/ /
| |___| \__ \ |_  | |_) | | (_) | (__|   < 
|_____|_|___/\__| |_.__/|_|\___/ \___|_|\_*/
.list-columns-block ul {
  padding: 0;
  display: grid;
  gap: 25px;
}
.list-columns-block ul li {
  list-style: none;
  font-size: 16px;
  font-weight: 600;
}
.list-columns-block--split-1 ul {
  grid-template-columns: 1fr;
}
.list-columns-block--split-2 ul {
  grid-template-columns: 1fr 1fr;
}
.list-columns-block--split-3 ul {
  grid-template-columns: 1fr 1fr 1fr;
}

/*_____        __      ____     __     
|_   _|____  _| |_   / ___|___ | |___ 
  | |/ _ \ \/ / __| | |   / _ \| / __|
  | |  __/>  <| |_  | |__| (_) | \__ \
  |_|\___/_/\_\\__|  \____\___/|_|__*/
.text-columns-block h1, .text-columns-block h2, .text-columns-block h3 {
  text-align: center;
  margin-bottom: 50px;
}
.text-columns-block__cols {
  display: grid;
  gap: 25px;
}
.text-columns-block__cols--1 {
  grid-template-columns: 1fr;
}
.text-columns-block__cols--2 {
  grid-template-columns: 1fr 1fr;
}

/*_____         _     ___                 
|_   _|____  _| |_  |_ _|_ __ ___   __ _ 
  | |/ _ \ \/ / __|  | || '_ ` _ \ / _` |
  | |  __/>  <| |_   | || | | | | | (_| |
  |_|\___/_/\_\\__| |___|_| |_| |_|\__, |
                                   |__*/
.text-image-block__cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 5rem;
}
.text-image-block__cols__col__image img {
  width: 100%;
  height: auto;
}

/*___                            
|_ _|_ __ ___   __ _  __ _  ___ 
 | || '_ ` _ \ / _` |/ _` |/ _ \
 | || | | | | | (_| | (_| |  __/
|___|_| |_| |_|\__,_|\__, |\___|
                     |__*/
.image-block figure {
  margin: 0;
}
.image-block figure img {
  width: 100%;
  height: auto;
}
.image-block--full-width {
  grid-column: 1/4;
}

h1.is-splitting {
  opacity: 0;
  visibility: hidden;
}

h1.splitting-done {
  opacity: 1;
  visibility: visible;
}

h1.splitting-done .word {
  filter: blur(8px);
  display: inline-block;
  opacity: 0;
  transform: translateY(-20px);
  animation: blurReveal 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  animation-delay: calc(var(--word-index) * 0.05s);
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
h1 .whitespace {
  display: inline;
}

:root {
  --text-colour: #f1cfbc;
  --header-colour: #f1cfbc;
  --bg-colour: #134140;
}

body {
  font-family: "Montserrat", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1.25rem;
  background: var(--bg-colour);
  color: var(--text-colour);
  border: brown;
}
@media (max-width: 1024px) {
  body {
    font-size: 1rem;
  }
}
body a {
  color: white;
}

#main {
  view-transition-name: main;
}

ul.messages {
  z-index: 102;
  padding: 0;
}
ul.messages li {
  color: var(--bg-colour);
  background: var(--text-colour);
  padding: 20px;
  border-radius: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */